<div fxFill>
  <div fxLayout="row" fxLayoutAlign="start center" class="action-wrapper">
    <div fxFlex>
      <mat-slide-toggle [(ngModel)]="displayGroup">{{ 'live_tracking.grouped_by_group'|translate }}</mat-slide-toggle>
    </div>
    <div fxFlex>
      <flex-search-input [(ngModel)]="filterValue" [hintText]="'live.search.hint'|translate"></flex-search-input>
    </div>
  </div>

  <div>
    <phone-busy-agents [displayGroup]="displayGroup" [searchText]="filterValue"
      [header]="'livecall.agent_list.list_busy'| translate"></phone-busy-agents>
    <phone-available-agents [displayGroup]="displayGroup" [searchText]="filterValue"
      [header]="'livecall.agent_list.list_available'| translate"></phone-available-agents>
  </div>
</div>
